import { createReducer, on } from '@ngrx/store';
import * as SessionTimeActions from './session-times.actions';
import { SessionTime } from './session-times.models';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface SessionTimesState {
    sessionTimes: SessionTime[];
    isLoading: boolean;
    error: string | null;
}

export interface SessionTimeState {
    sessionTime: SessionTime;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialSessionTimesState: SessionTimesState = {
    sessionTimes: [],
    isLoading: false,
    error: null,
};

export const initialSessionTimeState: SessionTimeState = {
    sessionTime: null,
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// All SessionTimes Reducer
export const sessionTimesReducer = createReducer(
    initialSessionTimesState,

    // On Load SessionTimes
    on(SessionTimeActions.loadSessionTimes, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        SessionTimeActions.loadSessionTimesSuccess,
        (state, { sessionTimes }) => ({
            ...state,
            isLoading: false,
            sessionTimes: sessionTimes,
        })
    ),
    on(SessionTimeActions.loadSessionTimesFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Create
    on(SessionTimeActions.createSessionTime, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        SessionTimeActions.createSessionTimeSuccess,
        (state, { sessionTime }) => ({
            ...state,
            isLoading: false,
            sessionTimes: [...state.sessionTimes, sessionTime],
        })
    ),
    on(SessionTimeActions.createSessionTimeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Update
    on(SessionTimeActions.updateSessionTime, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        SessionTimeActions.updateSessionTimeSuccess,
        (state, { sessionTime }) => ({
            ...state,
            isLoading: false,
            sessionTimes: state.sessionTimes.map((s) =>
                s.id === sessionTime.id ? sessionTime : s
            ),
        })
    ),
    on(SessionTimeActions.updateSessionTimeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Delete
    on(SessionTimeActions.deleteSessionTime, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SessionTimeActions.deleteSessionTimeSuccess, (state, { id }) => ({
        ...state,
        isLoading: false,
        sessionTimes: state.sessionTimes.filter((s) => s.id !== id),
    })),
    on(SessionTimeActions.deleteSessionTimeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);

// Single SessionTime Reducer
export const sessionTimeReducer = createReducer(
    initialSessionTimeState,

    // On Load Single SessionTime
    on(SessionTimeActions.loadSessionTime, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SessionTimeActions.loadSessionTimeSuccess, (state, { sessionTime }) => ({
        ...state,
        isLoading: false,
        sessionTime: sessionTime,
    })),
    on(SessionTimeActions.loadSessionTimeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);
